import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const DiagonalUpwardArrowIcon = () => {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.51111 6V8.55066H13.6467L6.37368 15.8217C5.87544 16.32 5.87544 17.1277 6.37368 17.6259C6.62366 17.8742 6.94845 18 7.27665 18C7.60315 18 7.92794 17.8742 8.17791 17.6259L15.4493 10.3548V14.4886H18V6H9.51111Z",
      fill: "currentColor"
    })
  });
};